import { cloneDeep } from 'lodash';
import { getDataSourceSrv } from '@grafana/runtime';
import { getDataSourceRef } from '@grafana/data';

import { AdHocVariableModel } from '../types';
import { dispatch } from '../../../store/store';
import { VariableAdapter } from '../adapters';
import { AdHocPicker } from './picker/AdHocPicker';
import { adHocVariableReducer, initialAdHocVariableModelState } from './reducer';
import { AdHocVariableEditor } from './AdHocVariableEditor';
import { setFiltersFromUrl } from './actions';
import * as urlParser from './urlParser';
import { isAdHoc, isLegacyAdHocDataSource } from '../guard';

const noop = async () => {};

export const createAdHocVariableAdapter = (): VariableAdapter<AdHocVariableModel> => {
  return {
    id: 'adhoc',
    description: 'Add key/value filters on the fly.',
    name: 'Ad hoc filters',
    initialState: initialAdHocVariableModelState,
    reducer: adHocVariableReducer,
    picker: AdHocPicker,
    editor: AdHocVariableEditor,
    dependsOn: () => false,
    setValue: noop,
    setValueFromUrl: async (variable, urlValue) => {
      const filters = urlParser.toFilters(urlValue);
      await dispatch(setFiltersFromUrl(variable.id, filters));
    },
    updateOptions: noop,
    getSaveModel: (variable) => {
      const { index, id, state, global, ...rest } = cloneDeep(variable);
      return rest;
    },
    getValueForUrl: (variable) => {
      const filters = variable?.filters ?? [];
      return urlParser.toUrl(filters);
    },
    beforeAdding: (model) => {
      if (!isAdHoc(model)) {
        return model;
      }

      if (!isLegacyAdHocDataSource(model.datasource)) {
        return model;
      }

      const ds = getDataSourceSrv().getInstanceSettings(model.datasource);
      if (!ds) {
        return model;
      }

      const clone = cloneDeep(model);
      clone.datasource = getDataSourceRef(ds);

      return { ...clone };
    },
  };
};
